// Override Settings
if(typeof boostPFSThemeConfig !== 'undefined') {
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      /* Optional */
      loadProductFirst: false,
      refineByStyle: 'style2',
      filterTreeMobileIcon: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-filter" viewBox="0 0 64 64"><path d="M48 42h10M48 42a5 5 0 1 1-5-5 5 5 0 0 1 5 5zM7 42h31M16 22H6M16 22a5 5 0 1 1 5 5 5 5 0 0 1-5-5zM57 22H26"></path></svg>'
      
    },
    selector: {
      avoidStickyHeader: '.site-header, .site-header--opening, #shopify-section-header'
    }
  };
}

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;
(function() {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  boostPFSFilterConfig.general.separateRefineByFromFilter = (jQ('.boost-pfs-filter-tree-h').length && !Utils.isMobile() > 0 && boostPFSThemeConfig.custom.filter_tree_horizontal_style != 'style-expand') ? true : false;

  /************************** BUILD PRODUCT LIST **************************/

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    //console.log(data);
    //console.log(Utils.getProductMetafield(data, 'custom', 'badges'));
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    itemHtml = itemHtml.replace(/{{grid_item_width}}/g, boostPFSConfig.custom.grid_item_width);
    itemHtml = itemHtml.replace(/{{products_per_row}}/g, boostPFSConfig.custom.products_per_row);

    // Add Thumbnail
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : '100';
    var thumb = images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
    var productGridImageFillClass = '';
    if(boostPFSConfig.custom.hasOwnProperty('product_grid_image_fill') && boostPFSConfig.custom.product_grid_image_fill){
      productGridImageFillClass = 'grid__image-contain';
    }
    var itemImagesHtml = '';
    if (boostPFSConfig.custom.product_grid_image_size == 'natural') {
      itemImagesHtml += '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">';
      itemImagesHtml += '<img ' +
                  'class="grid-product__image lazyload" ' +
                  'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
                  'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                  'data-aspectratio="' + aspectRatio + '" ' +
                  'data-sizes="auto" ' +
                  'alt="{{itemTitle}}">';
      itemImagesHtml += '<noscript>' +
                '<img class="grid-product__image lazyloaded" ' +
                'src="' + Utils.getFeaturedImage(images, '400x') + '" ' +
                'alt="{{itemTitle}">' +
              '</noscript>';
      itemImagesHtml += '</div>';

    } else {
      itemImagesHtml += '<div class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + '" >';
      itemImagesHtml += '<img ' +
        'class="lazyload ' + productGridImageFillClass + '" ' +
        'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
        'data-widths="[360, 540, 720, 900, 1080]" ' +
        'data-aspectratio="' + aspectRatio + '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">';
      itemImagesHtml += '</div>';
    }

    if (!soldOut) {
      if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
        itemImagesHtml += '<div class="grid-product__secondary-image small--hide">';
        itemImagesHtml += '<img class="lazyload"' +
          'data-src="' + Utils.optimizeImage(images[1].src, '{width}x') + '"' +
          'data-widths="[360, 540, 720, 900, 1080]"' +
          'data-aspectratio="' + aspectRatio + '"' +
          'data-sizes="auto"' +
          'alt="{{itemTitle}}">';
        itemImagesHtml += '</div>';
      }
    }

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
      itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
    }
    if (priceVaries) {
      itemPriceHtml += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min));
    } else {
      itemPriceHtml += Utils.formatMoney(data.price_min);
    }
    if (onSale && boostPFSConfig.custom.product_save_amount) {
      var savePrice = '';
      if (boostPFSConfig.custom.product_save_type == 'dollar') {
        savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
      } else {
        savePrice = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min);
        savePrice += '%';
      }
      var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
      itemPriceHtml += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    var customLabel = '';
    data.tags.forEach(function(tag) {
      if (tag.startsWith('_label_')) {
        if (!customLabel) {
          customLabel = tag.replace('_label_', '');
        }
      }
    });
    var itemLabelHtml = '';
    if (customLabel) {
      itemLabelHtml = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>';
    } else {
      // soldOut Label
      if (soldOut) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + '</div>';
      } else if (onSale) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sale">' + boostPFSConfig.label.sale + '</div>';
      }
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    var itemJscLabel = '';
    itemJscLabel += '<div class="jsc-grid-product-label">';
    data.tags.forEach(function(tag) {
      if (tag.indexOf('label') > -1) {
        if (tag.indexOf('label1') > -1) {
          var label1 = tag.split('_').slice(-1)[0];
          itemJscLabel += '<div class="general-label first-label label-' + label1 + '"><span>' + label1.replace(/\-/g, ' ') + '</span></div>';
        }
        if (tag.indexOf('label2') > -1) {
          var label2 = tag.split('_').slice(-1)[0];
          itemJscLabel += '<div class="general-label second-label label-' + label2 + '"><span>' + label2.replace(/\-/g, ' ') + '</span></div>';
        }
      }
    });
    itemJscLabel += '</div>';
    itemHtml = itemHtml.replace(/{{itemJscLabel}}/g, itemJscLabel);

    // if (onSale && boostPFSConfig.custom.product_save_amount) {
    //   var itemScLabelBR = '';
    //   itemScLabelBR += '<div class="grid-product-label-bottom-right">';
    
    //   var savePrice = '';
    //   // console.log(data.compare_at_price);
    //   // console.log(data.price);
    //   savePrice = Math.round((data.compare_at_price - data.price) * 100 / data.compare_at_price);
    //   savePrice += '% off';
      
    //   var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
    //   itemScLabelBR += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
    //   itemScLabelBR += '</div>';
    //   itemHtml = itemHtml.replace(/{{itemScLabelBR}}/g, itemScLabelBR);
    // }

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Quick shop
    var itemQuickShopClass = '';
    var itemQuickShopButtonHtml = '';
    if (boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopClass = 'grid-product__has-quick-shop';
      itemQuickShopButtonHtml = '<div class="quick-product__btn quick-product__btn--not-ready js-modal-open-quick-modal-{{itemId}} small--hide ' + (isFirstLoad ? '' : 'bc-hide') + '" data-product-id="{{itemId}}">' +
        '<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
        '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      var reviewHtml = '';
      if(boostPFSConfig.custom.enable_product_reviews) {
        reviewHtml = '<span class="shopify-product-reviews-badge" data-id="'+ data.id +'"></span>';
      }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);
    }

    // Color swatch
    var swatchHtml = buildSwatch(data, this);
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
    itemHtml = itemHtml.replace(/{{itemSwatchHoverImages}}/g, swatchHtml.itemSwatchHoverImages);

    var itemQuickShopModal = '';

    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopModal = '<div id="QuickShopModal-{{itemId}}" class="modal modal--square modal--quick-shop" data-product-id="{{itemId}}">' +
        '<div class="modal__inner">' +
          '<div class="modal__centered">' +
            '<div class="modal__centered-content">' +
              '<div id="QuickShopHolder-{{itemHandle}}"></div>' +
            '</div>' +

            '<button type="button" class="modal__close js-modal-close text-link">' +
              '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>' +
              '<span class="icon__fallback-text">Close Modal</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopModal}}/g, itemQuickShopModal);

    // Add badge meta
    var itemBadgeMeta = '';
    if (Utils.getProductMetafield(data, 'custom', 'badges') !== null) {
      itemBadgeMeta += '<div class="jsc-product-badge">';
      itemBadgeMeta += '<span>' + Utils.getProductMetafield(data, 'custom', 'badges') + '</span>';
      itemBadgeMeta += '</div>'
    }
    itemHtml = itemHtml.replace(/{{itemBadgeMeta}}/g, itemBadgeMeta);
    
    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, boostPFSAppConfig.general.collection_handle+'/products/'+data.handle);
    //itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

    // Add banner html
    if (boostPFSThemeConfig.custom.grid_banner_1) {
      var grid_banner_1_index = boostPFSThemeConfig.custom.grid_banner_1[0].split('|')[0].split('pos')[1];
      var grid_banner_1_imgUrl = boostPFSThemeConfig.custom.grid_banner_1[0].split('|')[1];
      var grid_banner_1_Url = boostPFSThemeConfig.custom.grid_banner_1[0].split('|')[2];
      var bannerHtml1 = buildItemBannerHtml(grid_banner_1_imgUrl,grid_banner_1_Url);
      var banner1Pos = grid_banner_1_index -2;
      if (index == banner1Pos) itemHtml += bannerHtml1;
      
    }
    if (boostPFSThemeConfig.custom.grid_banner_2) {
      var grid_banner_2_index = boostPFSThemeConfig.custom.grid_banner_2[0].split('|')[0].split('pos')[1];
      var grid_banner_2_imgUrl = boostPFSThemeConfig.custom.grid_banner_2[0].split('|')[1];
      var grid_banner_2_Url = boostPFSThemeConfig.custom.grid_banner_2[0].split('|')[2];
      var bannerHtml2 = buildItemBannerHtml(grid_banner_2_imgUrl,grid_banner_2_Url);
      var banner2Pos = grid_banner_2_index -3;
      if (index == banner2Pos) itemHtml += bannerHtml2;
    }

    /*Item add to bag meta content by JSC*/
    let checkDiscountPrice = false;
    let prodTitle = data.title.toLowerCase();
    let varTitle = '';
    let varId = '';
    let varAvail = '';
    let varPrice = '';
    let varComparePrice = '';
    let buttonText = '';

    let megaDataHtml = `<div class="jsc-grid-atb-button">
      <div class="jsc-grid-variants ">`;
    
    if(prodTitle.indexOf('gift card') > -1){
      megaDataHtml += `<a href="${theme.shop_url}/products/gift-card-1" width="100%">
    
        <div class="jsc-grid-var-option jsc-selected d-block">
          <span>VIEW OPTIONS</span>
        </div>
      </a>`;
    }else{
      data.variants.forEach((variant, index) => {
        //console.log(variant);
        if(data.variants.length > 1){
          let classes = (index == 0)?'jsc-selected m-r-2':'';
          classes += (variant.available == false)?'jsc-var-unavailable':''; 
          classes += (index == 2)?'m-l-2':'';
          megaDataHtml += `<div class="jsc-grid-var-option ${classes}" 
          onclick="jscVarSelected(this,'${variant.titl}','${variant.id}','${Utils.formatMoney(variant.price)}','${variant.available}','${variant.image}','${variant.compare_at_price}','${variant.price}')">
            <span>${variant.title}</span>
          </div>`
          if(index == 0){
            varTitle = variant.title;
            varId = variant.id;
            varAvail = variant.available;
            varPrice = variant.price;
            varComparePrice = variant.compare_at_price;
            if(variant.compare_at_price > variant.price){
              checkDiscountPrice = true;
            }
          }
        } else{
          varTitle = variant.title
          varId = variant.id
          varAvail = variant.available
          varPrice = variant.price
          varComparePrice = variant.compare_at_price;
    
          if(variant.title == 'Default Title'){
            let classes = (index == 0)?'jsc-selected':'';
            classes += (variant.available == false)?'jsc-var-unavailable':'';
            megaDataHtml += `<div class="jsc-grid-var-option ${classes}">
              <span>One Size</span>
            </div>`;
          } else{
            let classes = (index == 0)?'jsc-selected':'';
            classes += (variant.available == false)?'jsc-var-unavailable':'';
            megaDataHtml += `<div class="jsc-grid-var-option ${classes}">
              <span>${variant.title}</span>
            </div>`;
          }
          if(variant.compare_at_price > variant.price)
            checkDiscountPrice = true;
        }

        var itemScLabelBR = '';
        if (checkDiscountPrice) {
          itemScLabelBR += '<div class="grid-product-label-bottom-right">';
          var savePrice = '';
          savePrice = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          savePrice += '% off';
          
          var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
          itemScLabelBR += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
          itemScLabelBR += '</div>';
        }   
        itemHtml = itemHtml.replace(/{{itemScLabelBR}}/g, itemScLabelBR);  
    
        
      });
    }
    megaDataHtml += `</div>`;
    
    
    if(varAvail){
      buttonText = 'Add to bag';
    }else{
      buttonText = 'Notify Me';
    }
    megaDataHtml += `<input type="hidden" class="jsc-data-var-atb" data-var-title="${varTitle}" data-var-id="${varId}" data-var-avail="${varAvail}" data-var-price="${Utils.formatMoney(varPrice)}" data-var-compare="${Utils.formatMoney(varComparePrice)}">`;
    
    let dataJson = JSON.stringify(data);
    let dataAllJson = boostPFSConfig.product_json;
    dataAllJson.forEach((arr)=>{
      //console.log(typeof(arr));
      if(arr.indexOf(data.id) > -1){
        dataJson = arr;
        return;
      }
    });
    //console.log(dataJson);
    if(prodTitle.indexOf('gift card') > -1){  
      megaDataHtml += `<a href="${theme.shop_url}/products/gift-card-1" width="100%">
          <div class="jsc-grid-atb-style">
            <div class="jsc-grid-btn-title" data-product-data="${dataJson}">
              Add to bag
            </div>
          </div>
        </a>`
    } else{
      let classes = (!varAvail)?'BIS_trigger jsc-grid-notifyme':'';
      if(varAvail){
        megaDataHtml += `<div class="jsc-grid-atb-style" onclick="jscATB(this);" data-product-data="${dataJson}">`;
      } else{
        megaDataHtml += `<div class="jsc-grid-atb-style ${classes}" data-product-data="${dataJson}">`;
      }
      classes = (checkDiscountPrice)?'jsc-grid-discount-price':'';
      megaDataHtml += `<span class="jsc-grid-price fontWeight-6 ${classes}">${Utils.formatMoney(varPrice)}</span>`;
      classes = (!varAvail)?'BIS_trigger bis-collection-button button jsc-grid-notifyme':'';
      megaDataHtml += `<div data-add-to-cart-text data-default-text="${buttonText}" class="jsc-grid-btn-title ${classes}" data-product-data='${dataJson}'>
            ${buttonText}
          </div>
        </div>`;
    }
    megaDataHtml += `</div>`;

    //console.log(megaDataHtml);

    itemHtml = itemHtml.replace(/{{itemMetaData}}/g, megaDataHtml);


    return itemHtml;
  };

   // Build Item Banner Html
    function buildItemBannerHtml(imgUrl,bannerUrl) {
      var itemBannerHtml = boostPFSTemplate.productGridBanner;
      if(imgUrl.indexOf('.mp4') !== -1) {
        var itemBannerImage = '<video src="' + imgUrl + '" width="100%" height="auto" type="video/mp4" loop="" muted="" playsinline="" autoplay="" controlslist="nodownload" disablepictureinpicture="">';
      } else if (imgUrl.indexOf('youtube') != -1 || imgUrl.indexOf('youtu.be') != -1){
        var itemBannerImage = '<iframe class="banner-video-youtube"width="420" height="315" src="' + covertEmbedYoutubeLink(imgUrl) + '"></iframe>';
      } else {
        var itemBannerImage = '<img src="' + imgUrl + '" type="video/mp4">';
      }
      itemBannerHtml = itemBannerHtml.replace(/{{grid_item_width}}/g, boostPFSConfig.custom.grid_item_width);
      itemBannerHtml = itemBannerHtml.replace(/{{products_per_row}}/g, boostPFSConfig.custom.products_per_row);
      itemBannerHtml = itemBannerHtml.replace(/{{itemBannerImage}}/g, itemBannerImage);
      itemBannerHtml = itemBannerHtml.replace(/{{bannerUrl}}/g, bannerUrl);
      return itemBannerHtml;
  }

  function covertEmbedYoutubeLink(url) {
    var newUrl = '';
    if (url.indexOf('youtube.com') !== -1) {
      newUrl = url.replace('youtube.com','youtube.com/embed')
    }
    if (url.indexOf('youtu.be') !== -1) {
      newUrl = url.replace('youtu.be','youtube.com/embed');
    }
    return newUrl;
  }


  // Build Swatch
  function buildSwatch(data, _this) {
    var itemSwatchHtml = '';
    var itemSwatchHoverImagesHtml = '';
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchHoverImages = [];
      data.options_with_values.forEach(function(option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1) {
          var option_index = index;
          var values = [];
          data.variants.forEach(function(variant) {
            var value = variant.merged_options[option_index].split(':')[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var colorImage = Utils.optimizeImage(boostPFSAppConfig.general.file_url.replace('/?', '/' + colorValueSlugify + '.png?'), '50x');
              var variantImage = Utils.optimizeImage(variant.image, '400x');

              var swatchItem = '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                'data-variant-id="{{variantId}}" ' +
                'data-variant-image="{{variantImage}}" ' +
                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                '</a>';

              swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
              swatchItem = swatchItem.replace(/{{colorValueSlugify}}/g, colorValueSlugify);
              swatchItem = swatchItem.replace(/{{swatchClass}}/g, variant.image ? 'color-swatch--with-image' : '');
              swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
              swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
              swatchItem = swatchItem.replace(/{{backgroundColor}}/g, colorValueSlugify.split('-').pop());

              var swatchHoverImage = '<div class="grid-product__color-image grid-product__color-image--' + variant.id + ' small--hide"></div>';

              swatchItems.push(swatchItem);
              swatchHoverImages.push(swatchHoverImage);
            }
          });
        }
      });
      if (swatchItems.length > 1) {
        itemSwatchHtml = ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' + swatchItems.join('') + '</div>';
        itemSwatchHoverImagesHtml = swatchHoverImages.join('');
      }
    }
    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml
    };
  }



  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = '';
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {

      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return '';
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    var sortingArr = Utils.getSortingList();
    //console.log(sortingArr)
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    }
    return html;
  };

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    this.buildExtrasProductListByAjax(data, 'boost-pfs-addtobag', function(results) {
        results.forEach(function(result) {
            jQ('[data-product-id="' + result.id + '"]').find('.grid-product__content').append(result.addtobag.trim());
        });
    });

    // Hover color swatch
    onColorSwatchHover();
    if (typeof StampedFn !== 'undefined' && typeof StampedFn.loadBadges == 'function') { StampedFn.loadBadges(); }
  };

  function onColorSwatchHover() {
    document.querySelectorAll('.color-swatch--with-image').forEach(swatch => {
      swatch.addEventListener('mouseenter', function() {
        var id = swatch.dataset.variantId;
        var image = swatch.dataset.variantImage;
        var el = document.querySelector('.grid-product__color-image--' + id);
        el.style.backgroundImage = 'url(' + image + ')';
        el.classList.add('is-active');
      });
      swatch.addEventListener('mouseleave', function() {
        var id = swatch.dataset.variantId;
        document.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
      });
    });
  }

  /* buildAdditionalElements */
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;

    // Call theme init function
    //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
    jQ(document).ready(function() {
      if (typeof theme !== null && window.theme) {
        if(typeof AOS != 'undefined' && typeof AOS.refreshHard == 'function'){
          AOS.refreshHard();
        }
        // Setup page transition classes
        if (typeof theme.pageTransitions == 'function') {
          theme.pageTransitions();
        }

        // Quickview button: Use boost otp & otp style 3, disable add to cart

        // // Reload products inside each quick shop
        // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
        if (window.$ && typeof $ == 'function') {
          $(window).off('popstate');
        }
      }

      if (isFirstLoad) {
        isFirstLoad = false;
      }

      // jQ('.js-drawer-open-collection-filters').on('click', function() {
      //   jQ('.' + Class.filterOption).each(function() {
      //     var showMoreType = jQ(this).data('show-more-type');
      //     if (showMoreType && jQ(this).data('display-type') != 'range') {
      //       self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
      //     }
      //   });
      // });
    });
    // Add modal container for quickview
    var isReinitQuickview = !isFirstLoad || Utils.isSearchPage() || Globals.queryParams.hasOwnProperty('_');
    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable && isReinitQuickview) {
      jQ('.boost-pfs-quick-shop-modal-container').html('');
      if (data.products.length > 0) {
        data.products.forEach(function(product){
          var quickUrl = Utils.buildProductItemUrl(product) + '?view=boost-pfs-quickview';
          jQ.ajax({url: quickUrl, success: function(result) {
            numberQuickViewModalLoaded++;
            jQ('.boost-pfs-quick-shop-modal-container').append(result);
            if (numberQuickViewModalLoaded == data.products.length) {
              theme.collapsibles.init();
              numberQuickViewModalLoaded = 0;
              jQ('.quick-product__btn').removeClass('bc-hide');
            }
          }});
        });
      }
    }

    // Build total products text
    var totalProductText = '';
    if (data.total_product == 1) {
      totalProductText = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
    } else {
      totalProductText = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
    }
    jQ('.boost-pfs-filter-total-product').html(totalProductText);

    // Build filter button text on mobile
    // var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
    // if (numSelectedFilter) {
    //   jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
    //   jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
    // } else {
    //   jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
    //   jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
    // }
    theme.initQuickShop();
  };

  /* Math qual Height */
  function equalHeight(data) {
    var equal_i = -1;
    var equal_els = [];
    var equal_element = null;
  
    // Equal Height Title
    jQ('.boost-pfs-filter-products .grid-product').each(function(i, element) {
  
      var offsetTop = jQ(element).offset().top;
      if (!equal_element || equal_element.offset().top !== offsetTop) {
        equal_element = jQ(element);
        equal_i++;
      }
  
      if (!equal_els[equal_i]) {
        equal_els[equal_i] = [];
      }
      equal_els[equal_i].push(element);
    });
    
    for (var i = 0; i < equal_els.length; i++) {
      var max = 0;
      var iLength = equal_els[i].length;
  
      for (var j = 0; j < equal_els[i].length; j++) {
        var item = equal_els[i][j];
        var height = jQ(item).hasClass('grid-banner') ? 0 : jQ(item).height();
        max = Math.max(max, height + 61);
        jQ(equal_els[i]).find('.banner_image img').css({ 
          'height': max,
          'width': '100%',
          'object-fit': 'fill'
        });
      }
    }
    //console.log(max)
  }
  // Boost 154337
  FilterApi.beforeCall = function(eventType, eventInfo) {
    /* Change the filter params before calling api */
    if(Globals.queryParams.page === 1 ){
      Globals.queryParams.limit = 26;
    }
    else{
      Globals.queryParams.limit = 28;
    }
    /* No need to return anything */
}
  // End Boost 154337
})();